export function truncNumber(
  value: number | null | undefined,
  decimalPlaces: number,
) {
  return typeof value === 'number'
    ? Math.trunc(value * Math.pow(10, decimalPlaces)) /
        Math.pow(10, decimalPlaces)
    : value;
}
